import { ErrorMessage } from "@hookform/error-message";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";

function RefundRejectModal({
  showRefundModal,
  handleCloseRefundModal,
  refundProcessTrigger,
  revenueTransactionDataMutate,
  transactionId,
}) {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const closeModal = () => {
    reset();
    handleCloseRefundModal();
  };

  const onSubmit = async (data) => {
    const refundProcessPayload = {
      id: transactionId,
      status: 12,
      refundRequestRejectReason: data?.refundRequestRejectReason ?? "",
      createdAt: Date.now(),
    };
    await refundProcessTrigger(refundProcessPayload);
    closeModal();
    revenueTransactionDataMutate();
  };
  return (
    <Modal show={showRefundModal} onHide={closeModal} size="lg" centered>
      <Modal.Header>
        <Modal.Title>Refund Reject</Modal.Title>
        <button
          type="button"
          className="btn btn-sm btn-dark py-1 ms-auto"
          onClick={closeModal}>
          Close
        </button>
      </Modal.Header>
      <Modal.Body className="py-6 pt-0 px-4">
        <Form
          onSubmit={handleSubmit(onSubmit)}
          className="form form-label-right bg-table-bg-clr p-5 rounded-fix">
          <p className="text-black font-size-sm fw-medium">
            As you have decided to reject this
          </p>
          <div className="form-group mb-5">
            <div name="manageContract">
              <div className="mt-3 bg-white floating-input-field-wrapper-textarea pt-7">
                <label className="floating-input-field-label-static start-0 ms-4">
                  Write a reason why you rejecting this
                </label>
                <textarea
                  {...register("refundRequestRejectReason", {
                    required: {
                      value: true,
                      message: "Reject reason is required",
                    },
                  })}
                  className="form-control bg-transparent floating-input-field-item"
                  type="textarea"
                  name="refundRequestRejectReason"
                />
              </div>
              <ErrorMessage
                errors={errors}
                name="refundRequestRejectReason"
                render={({ message }) => (
                  <div className="invalid-feedback d-block">{message}</div>
                )}
              />
            </div>
          </div>

          <div className="mt-4 d-flex align-items-center justify-content-end">
            <Button
              variant="outline"
              className="text-text-clr font-size-sm fw-medium"
              onClick={closeModal}>
              Cancel
            </Button>
            <Button
              variant="secondary"
              className="font-size-sm text-white py-2"
              type="submit">
              Confirm
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
export default RefundRejectModal;
